import { render } from "./PurchaseOrderList.vue?vue&type=template&id=f946a89c&scoped=true"
import script from "./PurchaseOrderList.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderList.vue?vue&type=script&lang=js"

import "./PurchaseOrderList.vue?vue&type=style&index=0&id=f946a89c&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f946a89c"]])

export default __exports__